<template>
  <div class="body">
    <el-container>
      <div style="height: calc(100% - 100px); width: 100%;">
        <el-main style="padding-bottom: 0;"></el-main>
        <el-main>
          <div class="tipSearch">
            <el-form :inline="true" :model="form" class="demo-form-inline" size="mini">
              <el-form-item label="关键字">
                <el-input placeholder="关键字" v-model="form.fontName"></el-input>
              </el-form-item>
              <el-form-item label="日期">
                <el-date-picker
                  :picker-options="pickerOptions"
                  align="right"
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  type="daterange"
                  unlink-panels
                  v-model="time"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="厂商">
                <el-select placeholder="请选择" style="width:120px;" v-model="form.companyId">
                  <el-option
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-for="item in companyList"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                  @click="getTransformListByBatch"
                  style="margin-left:30px;"
                  type="primary"
                >查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <template>
            <div class="table">
              <el-table
                :data="tableData"
                @sort-change="sortChange"
                cell-click="cell"
                element-loading-background="rgba(0, 0, 0, 0.2)"
                element-loading-spinner="el-icon-loading"
                element-loading-text="拼命加载中"
                height="650"
                stripe
                style="width: 100%; "
                v-loading="loading"
              >
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-form class="demo-table-expand" label-position="left">
                      <el-form-item :key="i" label v-for="(item,i) in props.row.transformList">
                        <div class="expanditem">
                          <div class="createtime fg">{{item.createTime}}</div>
                          <div class="fontname fg">{{item.fontName}}</div>
                          <div class="srcExist fg">
                            <a
                              @click="fontDownload(item.id,'src',item.fontName)"
                              style="cursor: pointer;"
                              v-if="item.srcUrl"
                            >TrueType({{item.srcDownloadTime}})</a>
                          </div>
                          <div class="dstExist fg">
                            <a
                              @click="fontDownload(item.id,'dst',item.fontName)"
                              style="cursor: pointer;"
                              v-if="item.dstUrl"
                            >FullType({{item.dstDownloadTime}})</a>
                          </div>
                          <div class="company fg">{{item.company.name}}</div>
                          <div class="status fg">
                            <p :class="item.fontStyleId">{{typeData[item.status]}}</p>
                          </div>
                          <div class="errorMessage fg">{{item.errorMessage}}</div>
                          <div class="buttonBox fg">
                            <el-button
                              @click="fontReTransform(item.id)"
                              size="small"
                              type="danger"
                              v-if="item.status==='FAILED'"
                            >重新转换</el-button>
                          </div>
                        </div>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column label="创建时间" prop="createTime"></el-table-column>
                <el-table-column label="字体名" prop="fontName"></el-table-column>
                <el-table-column label="源文件">
                  <template slot-scope="scope">
                    <a
                      @click="fontDownload(scope.row.id,'src',scope.row.fontName)"
                      style="cursor: pointer;"
                      v-if="scope.row.srcExist"
                    >TrueType({{scope.row.srcDownloadTime}})</a>
                  </template>
                </el-table-column>
                <el-table-column label="转换文件">
                  <template slot-scope="scope">
                    <a
                      @click="fontDownload(scope.row.id,'dst',scope.row.fontName)"
                      style="cursor: pointer;"
                      v-if="scope.row.dstExist"
                    >FullType({{scope.row.dstDownloadTime}})</a>
                  </template>
                </el-table-column>
                <el-table-column label="厂商" prop="company.name"></el-table-column>

                <el-table-column label="状态" prop="status">
                  <template slot-scope="scope">
                    <p :class="scope.row.fontStyleId">{{typeData[scope.row.status]}}</p>
                  </template>
                </el-table-column>
                <el-table-column label="错误信息" prop="errorMessage"></el-table-column>
                <el-table-column fixed="right" label="操作">
                  <template slot-scope="scope">
                    <el-button @click="fontBatchDownload(scope.row)" size="small" type="danger">下载</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
          <div class="block">
            <el-pagination
              :current-page="form.page"
              :page-size="form.count"
              :page-sizes="[10, 20, 30, 100]"
              :total="total"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
          </div>
        </el-main>
      </div>
      <el-dialog :visible.sync="dialogVisible" before-close title="提示" top="7vh" width="50%">
        <img :src="imgpre" alt style="width:70%; object-fit: fill;" />
        <span class="dialog-footer" slot="footer"></span>
      </el-dialog>
    </el-container>
  </div>
</template>
<script>
import JsZip from 'jszip'
import FileSaver from 'file-saver'
import axios from 'axios'

export default {
  data() {
    return {
      form: {
        memberId: null,
        fontName: '',
        beginDate: '',
        endDate: '',
        companyId: null,
        page: 1,
        count: 20
      },
      time: [],
      page: 1,
      //page_native:1,
      loading: false,
      dialogVisible: false,
      tableData: [],
      companyList: [],
      total: 0,
      boolean: true,
      run: true, //是否能同步执行
      typeData: {
        SUCCESS: '成功',
        FAILED: '失败',
        WAITING: '转换中',
        FONT_BROKEN: '文件损坏'
      },

      imgpre: '',
      loadingInstance: null,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  //   watch: {
  //     '$route.path': function() {
  //       let a = this.$route.path.lastIndexOf('/')
  //       let b = this.$route.path.slice(a + 1, this.$route.path.length)
  //     }
  //   },
  mounted() {
    this.form.memberId = this.$store.state.memberId
    this.getCompanyByUser()
    this.getTransformListByBatch()
  },
  methods: {
    //全局加载界面
    startLoading() {
      this.loadingInstance = this.$loading({
        fullscreen: true,
        text: '拼命加载中...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
    },
    endLoading() {
      this.loadingInstance.close()
    },
    //翻页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.form.page = val
      this.getTransformListByBatch()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.form.count = val
      this.getTransformListByBatch()
    },

    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    //批次下载
    fontBatchDownload(row) {
      this.startLoading()
      let srcArray = [],
        dstArray = []
      row.transformList.forEach(e => {
        srcArray.push({
          src: e.fontName + '_src.ttf',
          url: e.srcUrl
        })
        dstArray.push({
          src: e.fontName + '_dst.ttf',
          url: e.dstUrl
        })
      })
      this.endLoading()
      // this.zipDownload(srcArray, 'TrueType')

      if (!dstArray.every(e => e.url === null)) {
        this.zipDownload(dstArray, 'FullType' + row.createTime)
      } else {
        this.$message({
          message: '没有字体文件可下载',
          type: 'error',
          duration: 2 * 1000
        })
      }
    },
    async zipDownload(array, type) {
      this.startLoading()
      const zip = new JsZip()
      const promises = []
      await array.forEach((item, idx) => {
        if (item.url) {
          const promise = this.getFile(item.url).then(async data => {
            await zip.file('/' + item.src, data, {
              binary: true
            }) // 逐个添加文件
          })
          promises.push(promise)
        }
      })
      Promise.all(promises).then(() => {
        zip
          .generateAsync({
            type: 'blob'
          })
          .then(content => {
            // 生成二进制流
            this.endLoading()
            FileSaver.saveAs(content, type) // 利用file-saver保存文件
            // this.getTransformListByBatch()
          })
      })
    },
    //下载文件流
    getFile(url) {
      // url = urlencode(url)
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url,
          responseType: 'arraybuffer'
        })
          .then(data => {
            resolve(data.data)
          })
          .catch(error => {
            reject(error.toString())
          })
      })
    },

    //接口方法
    getCompanyByUser() {
      this.$api.search.getCompanyByUser().then(res => {
        if (res.data.code == 0) {
          res.data.data.unshift({
            id: null,
            name: '全部'
          })
          this.companyList = res.data.data
        }
      })
    },
    getTransformListByBatch() {
      if (this.time.length) {
        this.form.beginDate = this.time[0] + ' 00:00:00'
        this.form.endDate = this.time[1] + ' 23:59:59'
      }
      this.$api.search.getTransformListByBatch(this.form).then(res => {
        if (res.data.code === 0) {
          let data = res.data.data
          this.tableData = data.list
          this.total = data.total
        }
      })
    },
    fontReTransform(id) {
      this.$api.search.fontReTransform(id).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: '重新转换请求成功',
            type: 'success',
            duration: 2 * 1000
          })
          this.getTransformListByBatch()
        }
      })
    },
    fontDownload(transformId, srcOrDst, fontName) {
      this.startLoading()
      this.$api.search.fontDownload(transformId, srcOrDst).then(res => {
        let blob = new Blob([res.data], {
          type: 'application/octet-stream'
        })
        FileSaver.saveAs(blob, `${fontName}_${srcOrDst}.ttf`)
        this.getTransformListByBatch()
        this.endLoading()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.body {
  width: 80%;
  margin: 0 auto;
  .header {
    width: 100%;
    height: 60px;
    background-color: #fff;
  }
}
.iconfont {
  font-size: 14px;
}
.iconfont:hover {
  color: #53ace7;
}
.choose:hover {
  color: #0080ff;
}

.form {
  background-color: #fff;
  padding: 0.5rem;
  margin: 0.5rem 0;
  display: flex;
  justify-content: space-between;
  align-content: center;
  flex-wrap: wrap;
  .tip {
    margin: 0 0 0 10px;
    height: 40px;
  }
}

.tipSearch {
  display: flex;
  justify-content: left;
  align-items: center;
  align-content: center;
  margin: 0;
  padding: 10px;
  padding-top: 22px;
  text-align: left;
  background-color: #fff;
  .title {
    margin-left: 10px;
  }
}
.block {
  padding: 10px;
  background-color: #fff;
}

.form1 {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  .el-form {
    margin: 0 auto;
  }
  .checkbox {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    flex-wrap: wrap;
  }
}
.table {
  margin-top: 1rem;
  background-color: #fff;
  .expanditem {
    padding: 0 0 0 98px;
    display: grid;
    grid-template-columns: repeat(8, 12.5%);
    .fg {
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  }
  /deep/ .cell {
    text-align: center;
    .ht {
      display: inline-block;
    }
  }
}

.el-main {
  padding: 10px;
}

.el-pagination {
  padding: 0;
  background-color: #fff;
}

li {
  list-style: none;
  text-align: center;
  line-height: 30px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-icon-user {
  font-size: 16px;
  color: azure;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 3px;
}
</style>
